import { Alert } from '@zillow/constellation';

import { PartialMessage } from '@zg-rentals/backend-styled-components';

import type { PartialMessageProps } from '@zg-rentals/backend-styled-components';

type Props = {
  appearance?: string;
  errorMessages: Array<PartialMessageProps>;
};

// TODO: refactor name of component to be more generic as it can also handle other appearance types other than error
const ErrorMessagesAlert = ({ appearance = 'error', errorMessages = [] }: Props) => (
  <Alert
    appearance={appearance}
    body={<PartialMessage data-testid="PartialMessage" partialMessages={errorMessages} />}
  />
);

export default ErrorMessagesAlert;
